import { MaintenanceJobAssignmentPayload } from 'aos-services/src/services/tasks/types/payload/MaintenanceTaskFormPayload'
import { TaskFormPayload } from 'aos-services/src/services/tasks/types/payload/TaskFormPayload'
import { BrushesVehicle } from 'aos-services/src/services/tasks/types/task/BrushesVehicle'
import { startCase } from 'lodash'

// `newBrushVehicle` only means anything while `brushesVehicle` is "Other" — reset
// it on every selection, not just when landing on "Other", so a value typed there
// cannot survive into the payload once the user picks a real vehicle instead.
export const vehicleChangePayload = (
    brushesVehicle: BrushesVehicle | null,
): Partial<MaintenanceJobAssignmentPayload> & Partial<TaskFormPayload> => ({
    brushesVehicle: brushesVehicle ?? undefined,
    title: startCase(brushesVehicle?.label),
    newBrushVehicle: undefined,
})
